export default {
  set_results: (state, data) => {
    state.results = data;
    state.searching = false;
    state.curpage = 1;
  },
  append_results: (state, data) => {
    state.results = state.results.concat(data);
    state.searching = false;
    state.curpage++;
  },
  set_has_other_data: (state, has_other_data) => {
    console.info("set_has_other_data", has_other_data);
    state.has_other_data = has_other_data;
  },
  set_term: (state, term) => (state.term = term),
  set_search_type: (state, search_type) => {
    if (state.search_type !== search_type) {
      state.results = [];
    }
    state.search_type = search_type;
  },
  set_searching: (state, value) => (state.searching = value),
};
